import { ProductUnknown } from "@/common/contracts/product.contracts";
import { cn } from "@/common/utils/css.utils";
import { useTranslation } from "next-i18next";

type DesignerItemLabelProps = {
  product?: ProductUnknown;
  className?: string;
};

export const DesignerItemLabel = ({
  product,
  className,
}: DesignerItemLabelProps) => {
  const { t } = useTranslation();

  if (!product?.isDesignerItem) {
    return null;
  }

  return (
    <span
      className={cn(
        "bg-flavour-100 px-2 py-1 font-title text-base text-brand-500",
        className
      )}
    >
      {t("common:common-designer-item")}
    </span>
  );
};
